const isApplePaySupported = Boolean(window.ApplePaySession);

export default isApplePaySupported;
